import { OM008SliceType } from "./../type/Presenter";
import { createSlice } from "@reduxjs/toolkit";

export const initialState: OM008SliceType = {
  loading: false,
  isVisible: false,
  groupInfo: {
    explanation: "",
    id: 0,
    name: "",
    totalMember: 0,
    status: {
      code: "",
      description: "",
      id: 0,
      name: "",
      type: "",
    },
    approver: {
      id: 0,
      fullName: "",
      username: "",
      address: "",
      email: "",
      phoneNumber: "",
    },
  },
};
export const om008Slice = createSlice({
  name: "om008",
  initialState,
  reducers: {
    resetOM008: () => initialState,
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setIsVisibleOM008: (state, action) => {
      state.isVisible = action.payload;
    },
    setGroupInfo: (state, action) => {
      state.groupInfo = action.payload;
    },
  },
});

export const { setLoading, setIsVisibleOM008, setGroupInfo, resetOM008 } =
  om008Slice.actions;

export default om008Slice.reducer;
